import React, { Component } from 'react'
import Link from 'next/link'
import { connect } from 'react-redux';
import { PushpinOutlined, PushpinFilled, MenuOutlined } from '@ant-design/icons';
import { Menu, Tooltip, Row, Col, Badge } from 'antd';
import { Trans, withTranslation } from 'react-i18next';
import { CATALOG_ROUTES } from '../../constants/CatalogRoutes';
import {PERMISSIONS, ROLES} from '../../constants/AuthConstants';
import BusinessUnitColors from '../../constants/BusinessUnitsColors';
import withRouterParams from '../common/RouterUtils';
import {
  downloadPricesList,
  setShowPricesListModal,
  setCatalogSegment,
  clearSearchProduct,
  toggleFixHeader,
  clearSegments,
  getNewsForFavorites,
  toggle_show_badge
} from '../../actions';
import {hasAccess} from "../../lib/AuthUtils";
import getConfig from "next/config";
import PricesListModal from "./download-prices-list-modal"

const { publicRuntimeConfig: { enableFavoritesFeature, testingEnabledUsers } } = getConfig();

const PARAM_FILTER = "filtro";
const PARAM_SORT = "orden";
const PARAM_LINEACATALOGOID = "lineaCatalogoId";
const PARAM_SEGMENTID = "segmentId";

function getItem(label, key, children, icon) {
  return {
    key,
    icon,
    children,
    label,
  };
}

class CatalogNavBar extends Component {
  constructor(props) {
    super(props);
  }

  handleFixHeaderClick = () => {
    this.props.toggleFixHeader();
  };

  handleClick = (e) => {
    switch (e.key) {
      case "catalog":
        break;

      default:
        break;
    }
  }

  componentDidMount(){
    const { role } = this.props.user
    if ((role.name === 'cliente' || role.name === 'vendedor')&& enableFavoritesFeature){
      this.props.getNewsForFavorites();
    }

    if (this.props.fixHeader === null && this.props.supportedBrowserVersion) {
      this.props.toggleFixHeader();
    }
  }

  handleUpdateSegment(segment){
    const params = this.getParams();
    this.updateURL({
      ...params,
      [PARAM_SEGMENTID]: segment.id
    }, true);
    this.props.setCatalogSegment(segment);
  }

  handleCatalogClick = () => {
    this.props.clearSegments();
    this.props.clearSearchProduct();
  };

  handleBadgeClick = () => {
    this.props.toggle_show_badge();
  };

  handleDownloadListPrices = () => {
    this.props.setShowPricesListModal();
  }

  getMenuItems() {
    const { user, t, favoritesBadgeFlag, prodWithDiff } = this.props;

    const items = [
      hasAccess(user, [PERMISSIONS.PAGE.ADMIN]) && getItem(
        <Link href={CATALOG_ROUTES.ADMIN}><a>{t('Administrator')}</a></Link>,
        'admin',
      ),
      hasAccess(user, [PERMISSIONS.PAGE.CATALOGO]) && getItem(
        <Link href={CATALOG_ROUTES.CATALOG}><a onClick={this.handleCatalogClick}>{t('Catalog')}</a></Link>,
        'catalog',
      ),
      hasAccess(user, [PERMISSIONS.PAGE.CATALOGO_DEALS]) && getItem(
        <Link href={'/catalog/deal'}><a>{t('Deals')}</a></Link>,
        'deals',
      ),
      hasAccess(user, [PERMISSIONS.PAGE.DOWNLOAD_PRICE_LIST]) && getItem(
        <a onClick={this.handleDownloadListPrices}>{t('Price list')}</a>,
        'priceList',
      ),
      ((user.role.name === ROLES.SALESMAN && user.vendedor.tipovendedor !== 't') || user.role.name === ROLES.ADMIN) && getItem(
        <Link href={'/accountForms'}><a>{t('ACCOUNT_OPENINGS.TITLE')}</a></Link>,
        'opening_account',
      ),
      (user.role.name === ROLES.ADMIN || user.role.name === ROLES.SALESMAN) && getItem(
        t('INVOICE.CREDIT_NOTE'),
        'creditNote',
        [
          getItem(
            <Link href={'/invoices'}><a>{t('INVOICE.REQUESTS')}</a></Link>,
            'invoices',
          ),
        ],
      ),
      hasAccess(user, [PERMISSIONS.PAGE.CATALOGO_CURRENT_ACCOUNTS]) && getItem(
        t('Current Accounts'),
        'currentAccount',
        [
          hasAccess(user, [PERMISSIONS.PAGE.CATALOGO_CURRENT_ACCOUNTS]) && getItem(
            <a href={CATALOG_ROUTES.CURRENT_ACCOUNT}>{t('currentAccount.BALANCE_INQUIRY')}</a>,
            'account',
          ),
          (testingEnabledUsers?.includes(user.id) ?? false) &&
          hasAccess(user, [PERMISSIONS.PAGE.PROVISIONAL_RECEIPTS]) &&
          getItem(
            <Link href={'/provisionalReceipts'}><a>{t('currentAccount.PROVISIONAL_RECEIPTS')}</a></Link>,
            'receipts',
          ),
          (testingEnabledUsers?.includes(user.id) ?? false) && 
          hasAccess(user, [PERMISSIONS.PAGE.BILLING_DETAIL]) && getItem(
            <Link href={'/billingDetail'}><a>{t('currentAccount.BILLING_DETAIL')}</a></Link>,
            'billingDetail',
          ),
        ].filter(Boolean),
      ),
      (hasAccess(user, [PERMISSIONS.PAGE.CATALOGO_ORDERS]) ||
        hasAccess(user, [PERMISSIONS.PAGE.CATALOGO_QUOTATIONS]) ||
        hasAccess(user, [PERMISSIONS.PAGE.CATALOGO_STATISTICS]) ||
        hasAccess(user, [PERMISSIONS.PAGE.APPOINTMENTS]) ||
        hasAccess(user, [PERMISSIONS.PAGE.DASHBOARD])) && getItem(
        t('My Account'),
        'myAccount',
        [
          hasAccess(user, [PERMISSIONS.PAGE.CATALOGO_ORDERS]) && getItem(
            <Link href={'/catalog/orders'}><a>{t('Orders')}</a></Link>,
            'orders',
          ),
          hasAccess(user, [PERMISSIONS.PAGE.CATALOGO_QUOTATIONS]) && getItem(
            <Link href={'/catalog/quotations'}><a>{t('Quotations')}</a></Link>,
            'quotations',
          ),
          hasAccess(user, [PERMISSIONS.PAGE.CATALOGO_STATISTICS]) && getItem(
            <a href={CATALOG_ROUTES.STATISTICS}>{t('Statistics')}</a>,
            'stats',
          ),
          hasAccess(user, [PERMISSIONS.PAGE.APPOINTMENTS]) && getItem(
            <Link href={'/appointments'}><a>{t('Appointments')}</a></Link>,
            'appointments',
          ),
          (user.role.name === ROLES.SALESMAN && user.supervisor === true) && getItem(
            <Link href={'/dashboard'}><a>{t('DASHBOARD')}</a></Link>,
            'dashboard',
          ),
        ].filter(Boolean),
      ),
      enableFavoritesFeature && hasAccess(user, [PERMISSIONS.PAGE.FAVORITE]) && getItem(
        <Link href={'/favorites'}>
          <a onClick={this.handleBadgeClick}>
            {t('FAVORITE.FAVORITES')}
            {favoritesBadgeFlag && prodWithDiff.existDifferences ? (
              <Tooltip title={t('Some of your favourite products have news')} placement="top">
                <Badge count={'!'} offset={[5, -3]}></Badge>
              </Tooltip>
            ) : null}
          </a>
        </Link>,
        'favorite',
      ),
    ].filter(Boolean); // Filter false boolean values

    return items;
  }

  render() {
    const { user, catalogSegment, router, supportedBrowserVersion, showPricesListModal } = this.props;
    const { segmentos } = user;
    const { fixHeader } = this.props;

    return (
      <div className="catalog-nav-bar hidden-print">
        <Row>
            <Col span={3}>
              {supportedBrowserVersion && (
                  <Tooltip title={<Trans>Fix Header</Trans>} placement="right">
                      {fixHeader ? (
                          <PushpinFilled
                              onClick={this.handleFixHeaderClick}
                              className="fix-header-icon active"
                          />
                      ) : (
                          <PushpinOutlined
                              onClick={this.handleFixHeaderClick}
                              className="fix-header-icon"
                          />
                      )}
                  </Tooltip>
              )}
            </Col>
            <Col span={18} >
              <Menu
                  onClick={this.handleClick}
                  mode="horizontal"
                  overflowedIndicator={<MenuOutlined style={{ fontSize: '18px', verticalAlign: 'text-bottom' }} />}
                  className="catalog-nav-bar-menu"
                  items={this.getMenuItems()}
                />
            </Col>
            <Col span={3}>
            { router.route === '/catalog' && /* Segment filters should only appear for catalog page */
              <div className={"catalog-nav-bar-business-units"}>
                { segmentos.map((unit, index) => {
                  const active = catalogSegment && unit.id === catalogSegment.id;
                  return (
                    <div className={`catalog-nav-bar-business-unit ${(active) ? 'catalog-nav-bar-business-unit-active' : ''}`} style={{ color: BusinessUnitColors[index] }} key={unit.descripcion.charAt(0)}>
                      <Tooltip title={unit.descripcion}>
                        <span style={{ cursor:'pointer' }} onClick={ () => this.handleUpdateSegment(unit) } >{unit.descripcion.charAt(0)}</span>
                      </Tooltip>
                    </div>
                  )
                })}
              </div>
            }
            </Col>
          </Row>
        { showPricesListModal && (<PricesListModal isModalOpen={showPricesListModal}/>)}
      </div>
    );
  }
}

const mapStateToProps = ({ auth, catalog, common }) => {
  const user = auth.user ? auth.user : null
  const fixHeader = common.fixHeader;
  const showPricesListModal = catalog.showPricesListModal;
  return { user, showPricesListModal, catalogSegment: catalog.catalogSegment, favoritesBadgeFlag: catalog.favoritesBadgeFlag, prodWithDiff: catalog.productsWithDifferences, fixHeader };
};

const mapDispatchToProps = dispatch => ({
  downloadPricesList: () => {
    dispatch(downloadPricesList());
  },
  setShowPricesListModal: () => {
    dispatch(setShowPricesListModal());
  },
  setCatalogSegment:(params) => {
    dispatch(setCatalogSegment(params));
  },
  clearSearchProduct: () => {
    dispatch(clearSearchProduct());
  },
  clearSegments: () => {
    dispatch(clearSegments())
  },
  getNewsForFavorites: () => {
    dispatch(getNewsForFavorites())
  },
  toggle_show_badge: () => {
    dispatch(toggle_show_badge())
  },
  toggleFixHeader: () => {
    dispatch(toggleFixHeader())
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(withRouterParams(CatalogNavBar, { [PARAM_LINEACATALOGOID]:PARAM_LINEACATALOGOID, [PARAM_FILTER]: PARAM_FILTER, [PARAM_SORT]: PARAM_SORT, [PARAM_SEGMENTID]: PARAM_SEGMENTID })));
